import { Link } from './router';
import { DASHBOARD_URL } from './config';

/**
 * Minimal nav: brand + the only two real destinations. No anchor-link
 * buttons — the page itself is the pitch; scrolling is the navigation.
 */
export function TopNav() {
  return (
    <nav className="topnav">
      <Link to="/" className="brand">
        Vocal Cord
      </Link>
      <Link to="/setup">For agents</Link>
      <a href={DASHBOARD_URL} className="signin">
        Sign in
      </a>
    </nav>
  );
}
